import type { ChatLink } from '../types'

// DB'de Twitter status URL'leri /i/status/<id> canonical formunda saklanıyor
// (username'siz, dedup için). Yayıncıya listede paylaşan kullanıcının username'ini
// göstermek için url_original'dan parse edip URL'i yeniden kuruyoruz.
//
// Tıklayınca da bu URL açılır — Twitter username'siz /i/ formundan farklı
// olarak gerçek profil URL'i, doğru tweet'e gider yine.
// Yayıncıya gösterilen + tıklanınca açılan URL: her durumda canonical link.url.
// Twitter status için /i/status/<id> şeklinde — tıklayınca Twitter doğru
// kullanıcıya yönlendirir. Author bilgisi twitterAuthor() rozetinde ayrı
// gösterildiği için URL'de username'i tekrarlamaya gerek yok.
export function displayUrl(link: ChatLink): string {
  return link.url
}

// twitterAuthor: link Twitter status ise paylaşan kullanıcı adını döner (@username
// rozeti için). Önce DB'deki twitter_author field'ı (oembed ile arka planda
// fetch edilir), yoksa url_original'dan parse — /i/status/ ise null döner.
export function twitterAuthor(link: ChatLink): string | null {
  if (link.twitter_author) return link.twitter_author
  if (!link.url.includes('twitter.com/i/status/')) return null
  const m = link.url_original.match(/(?:twitter|x)\.com\/([^/]+)\/status\/\d+/i)
  if (m && m[1].toLowerCase() !== 'i') return m[1]
  return null
}
